import { render } from "./gonggao.vue?vue&type=template&id=13f5539a"
import script from "./gonggao.vue?vue&type=script&lang=js"
export * from "./gonggao.vue?vue&type=script&lang=js"

import exportComponent from "C:\\huishan\\项目\\20250520 辉山官网\\源码\\官网-前端\\huishan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__